// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2cokU","footer":"styles_footer__21Tz3","passCodeTooltip":"styles_passCodeTooltip__4iCht"};